import { PortalStatus } from '@/shared/enums/portal-status.enum';

/**
 * Deriva a etapa do wizard RD a partir do `StatusPortal` da linha unificada.
 * As listas unificadas perdem o `RdStatus` (mapeado para PortalStatus), mas o
 * passo continua bem-definido: todo status de estágio cotação leva a CALCULATION,
 * `rascunho` a CLIENT_INFO e `aceita` a EMISSION.
 */
export function portalStatusToRdStep(statusPortal: number | string): string {
  const status = Number(statusPortal);
  switch (status) {
    case PortalStatus.QuoteInProgress: // 1 — rascunho
      return 'CLIENT_INFO';
    case PortalStatus.ProposalTransmitted: // 8 — aceita (transmitida, aguardando emissão manual)
      return 'EMISSION';
    default: // 3/17/2 — cotada/aguardando_analise/aprovada/cancelada
      return 'CALCULATION';
  }
}
